import env from "./env";
import { doAbortFetchIfPossible } from "./http-helper";

export const prepareHttpHeaders = (headers, skipAuthHeader) => {
  const apiToken = env("API_TOKEN");
  const bundleIdentifier = env("BUNDLE_ID");
  const locale = env("locale");

  const mobileAppRequestHeader = {
    bundle_identifier: bundleIdentifier,
    app_name: "MemberMobile",
    app_version: process.env.APP_VERSION, // replaced with package version at build time
    platform: "websdk",
    platform_version: null,
    device_info: "Simulator",
    device_token: "6A5320CB-BA30-49F2-812E-36D80EBF06E3",
    is_sdk: true,
    sdk_version: "4.4.0",
    locale
  };

  let baseHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Teladoc-API-Request-Token": apiToken,
    "mobile-app-request": JSON.stringify(mobileAppRequestHeader)
  };

  if (!skipAuthHeader) {
    const authToken = env("AUTH_TOKEN");
    const authMethod = env("AUTH_METHOD");
    const authenticationData = env("AUTHENTICATION_DATA");
    const clientRefreshToken = env("OAUTH_REFRESH_TOKEN");

    baseHeaders = {
      ...baseHeaders,
      Authorization: `${authMethod ?? "Bearer"} ${authToken}`
    };

    // Authentication-Data is only set if the value has been passed back in response_data
    // for internal_sdk permitted sdk clients
    if (authenticationData) {
      baseHeaders = {
        ...baseHeaders,
        "Authentication-Data": authenticationData
      };
    }

    if (clientRefreshToken) {
      baseHeaders = {
        ...baseHeaders,
        "Oauth-Refresh-Token": clientRefreshToken
      };
    }
  }

  return { ...baseHeaders, ...headers, ...(window.TELADOC_ENVELOP || {}) };
};

export const prepareHyHttpHeaders = headers => {
  const hyToken = env("HY_JWT_TOKEN");

  const baseHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };

  if (hyToken) {
    return { ...baseHeaders, ...headers, Authorization: hyToken };
  } else {
    return { ...baseHeaders, ...headers };
  }
};

export const stringifySearchParams = searchParams =>
  new URLSearchParams(searchParams).toString();

export const createAbortableFetcher = (url, config) => {
  let abortController;

  const doFetch = searchParams => {
    doAbortFetchIfPossible(abortController);

    abortController = new AbortController();
    let finalUrl = url;

    if (searchParams) {
      finalUrl += "?";

      if (typeof searchParams === "string") finalUrl += searchParams;

      if (typeof searchParams === "object")
        finalUrl += stringifySearchParams(searchParams);
    }

    return fetch(finalUrl, { ...config, signal: abortController.signal })
      .then(res => res.json())
      .catch(() => {});
  };

  const abortFetch = () => {
    doAbortFetchIfPossible(abortController);
  };

  return [doFetch, abortFetch];
};
